/**
 * Forces every dispatched action to follow the same standard https://github.com/acdlite/flux-standard-action.
 */
export const createAction = (type = "", payload = undefined, error = false, meta = null) => ({
  type,
  payload,
  error,
  meta,
});
